import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';

import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';

import { Params, draftSteps } from 'pages/Accounts/Edit/accountEditRoutes';
import useStyles from './styles/AccountStepper';
import { APP_CONFIG } from 'appConfig';

interface Props {
  active?: number;
  activeId?: string;
  steps?: { title: string; id?: string; route?: (accountId: string) => string }[];
  onChange?: Function;
  mobileBreak?: number;
}

const AccountStepper: React.FC<Props> = ({ active, activeId, steps, onChange, mobileBreak }) => {
  const classes = useStyles({ mobileBreak });
  const { t } = useTranslation();
  const history = useHistory();
  const { accountId } = useParams<Params>();
  const renderSteps = steps || draftSteps;

  if (activeId && !active) {
    active = renderSteps.findIndex(step => step.id === activeId)
  }

  useEffect(()=>{
    const activeStep = document.querySelector(`#step-${activeId}`);
    activeStep && activeStep.scrollIntoView();
  });


  return (
    <Stepper activeStep={active} className={classes.root} nonLinear={APP_CONFIG.uiSwitchTabs}>
      {renderSteps.map((step, key) => (
        <Step key={step.title} id={`step-${step.id}`}>
          <StepButton
            onClick={() => {
              step.route && history.push(step.route(accountId));
              if (onChange && active !== undefined && key <= active - 1) {
                onChange(step.id);
              }
            }}
            id={`workflow-${key}-step-button`}
            completed={active !== undefined && key <= active - 1}
            className={classes.button}
          >
            <StepLabel className={key === active ? 'active' : ''}>
              {t(step.title)}
            </StepLabel>
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
};

export default AccountStepper;
